import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=edd29952&scoped=true&"
import script from "./device-info.vue?vue&type=script&lang=ts&"
export * from "./device-info.vue?vue&type=script&lang=ts&"
import style0 from "./device-info.vue?vue&type=style&index=0&id=edd29952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd29952",
  null
  
)

export default component.exports